// product-sticky-cart.js — Die Cut Mart sticky Add to cart (desktop + mobile)
(function () {
  "use strict";

  function initStickyAtc(root) {
    if (!root || root.dataset.dcmInit === "true") return;
    root.dataset.dcmInit = "true";

    var sectionId = root.dataset.section;
    var strings = window.variantStrings || {};

    var variants = [];
    try {
      variants = JSON.parse(
        root.querySelector("[data-sticky-variants]").textContent
      );
    } catch (e) {
      variants = [];
    }

    var idInput = root.querySelector("[data-sticky-variant-id]");
    var priceEl = root.querySelector("[data-sticky-price]");
    var imageEl = root.querySelector("[data-sticky-image]");
    var addBtn = root.querySelector("[data-sticky-add]");
    var addText = root.querySelector("[data-sticky-add-text]");
    var toggle = root.querySelector("[data-sticky-toggle]");

    /* ---------- Follow the variant chosen in the main product form ---------- */
    function applyVariant(variantId) {
      var variant = null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(variantId)) {
          variant = variants[i];
          break;
        }
      }
      if (!variant) return;

      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price;
      if (imageEl && variant.image) imageEl.src = variant.image;

      if (addBtn) {
        if (variant.available) {
          addBtn.removeAttribute("disabled");
        } else {
          addBtn.setAttribute("disabled", "disabled");
        }
      }
      if (addText) {
        addText.textContent = variant.available
          ? strings.addToCart || "Add to cart"
          : strings.soldOut || "Sold out";
      }
    }

    // product-variant.js updates #product-form-{section} input[name="id"]
    // and dispatches a bubbling "change" event on it.
    document.addEventListener("change", function (event) {
      var target = event.target;
      if (
        target &&
        target.name === "id" &&
        target.closest &&
        target.closest("#product-form-" + sectionId)
      ) {
        applyVariant(target.value);
      }
    });

    // Sync once on load in case the page opened with ?variant=
    var mainIdInput = document.querySelector(
      "#product-form-" + sectionId + ' input[name="id"]'
    );
    if (mainIdInput) applyVariant(mainIdInput.value);

    /* ---------- Show only after the main buy buttons scroll out of view ---------- */
    function setVisible(show) {
      root.classList.toggle("is-visible", show);
      root.setAttribute("aria-hidden", show ? "false" : "true");
      document.body.classList.toggle("dcm-sticky-atc-open", show);
    }

    var mainForm = document.getElementById("product-form-" + sectionId);
    var watchTarget =
      (mainForm && mainForm.closest(".product_buy_button_form")) || mainForm;

    if (watchTarget && "IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        // Visible only when the main buttons are ABOVE the viewport (scrolled past),
        // not when the customer hasn't reached them yet.
        setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(watchTarget);
    } else {
      setVisible(true);
    }

    /* ---------- Desktop collapse / expand ---------- */
    if (toggle) {
      toggle.addEventListener("click", function () {
        var collapsed = root.classList.toggle("is-collapsed");
        toggle.setAttribute("aria-expanded", collapsed ? "false" : "true");
        toggle.setAttribute(
          "aria-label",
          collapsed ? "Expand sticky cart" : "Collapse sticky cart"
        );
      });
    }
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll(".dcm-sticky-atc")
      .forEach(initStickyAtc);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target || document);
  });
})();